import styled from 'styled-components';
import { Box, Button } from '@rsos/components/capstone/base';

export const StyledButton = styled(Button).attrs({
  btnType: 'secondary',
})`
  width: 100%;
  margin: 0;
`;

export const StyledCollapsibleItem = styled(Box).attrs({})`
  border-top: 1px solid ${({ theme }) => theme.colors.heavyLineOutline};
`;
